module.exports = __webpack_public_path__ + "img/minei-pe-luna-noiembrie-1698-pagina-de-titlu-big.890a85e9.jpg";